import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, OverlayLoader, UiButton, titleCase, UiTextArea, UiUserSelect, UiDatePicker } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";
import { notification, Flex, Spin } from "antd";
import { setStorage, getStorage } from "../helper.js";
import imageCompression from 'browser-image-compression';
import { IoMdClose } from "react-icons/io";
import { set } from "date-fns";
import { useQuery, useQueryClient, select } from "react-query";
import { Dropdown, Popconfirm, Timeline } from 'antd';


const ViewJob = NiceModal.create(
  ({ id }) => {
    const [state, setState] = useState({ count: 0 });

    const [originalImages, setOriginalImages] = useState([]);
    const [compressedImages, setCompressedImages] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [allImages, setAllImages] = useState([]);
    const [deletedImages, setDeletedImages] = useState([]);
    const [error, setError] = useState('');
    const [init_load, setInitLoad] = useState(false);


    const modal = useModal();

    const queryClient = useQueryClient()



    const fetchData = () => {
      instance
        .get("/jobs/" + id + "")
        .then(function (response) {
          setState(response.data.data)

          setInitLoad(true)


        })
        .catch(function (error) { })
        .then(function () { });
    }

    const accountModal = useModal('job');

    const addAccount = (id) => {
      accountModal.show({ id: id }).then((res) => {
        queryClient.invalidateQueries(['jobs'])
        //toast(response.data.msg, { type: "success" });
        modal.hide();
        modal.resolve({ resolved: true });
      });
    }



    useEffect(() => {
      if (id != 'new') {
        fetchData()
      } else {
        setInitLoad(true)
      }

    }, []);

    ;

    const handleDelete = (id) => {
      var tid = id.toString();

      instance
        .delete("/jobs/" + tid)
        .then(function (response) {
          if (response.status == 200) {
            queryClient.invalidateQueries(['jobs'])
            toast(response.data.msg, { type: "success" });
            modal.hide();
            modal.resolve({ resolved: true });
          } else {
            toast(response.data.msg, { type: "error" });
          }
        })
    }




    const handleHide = () => {
      modal.hide();
    }





    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Job #{id} <button onClick={() => addAccount(id)} className="btn btn-secondary btn-sm ms-2">Edit</button> <Popconfirm
            title="Delete?"
            description="Are you sure to delete this?"
            onConfirm={() => handleDelete(id)}
            okText="Yes"
            cancelText="No"
          >
            <button className="btn btn-danger btn-sm ms-2">Delete</button>
          </Popconfirm></BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={state.loader} />
        <BootstrapModal.Body>
          {init_load ?
            <div>
              <table className="table table-bordered">
                <colgroup>
                  <col style={{ width: "30%", color: "#ccc" }} />
                  <col style={{ width: "70%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>Date</td>
                    <td>{state.date}</td>
                  </tr>
                  <tr>
                    <td>Name</td>
                    <td>{state.name}</td>
                  </tr>
                  <tr>
                    <td>Mobile</td>
                    <td>{state.mobile}</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{state.city}</td>
                  </tr>
                  <tr>
                    <td>Item</td>
                    <td>{state.item}</td>
                  </tr>
                  <tr>
                    <td>Estimate</td>
                    <td>{state.estimate}</td>
                  </tr>
                  <tr>
                    <td>Estimate Time</td>
                    <td>{state.estimate_time}</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td><span className={`badge ${state.status}`}>{state.status}</span></td>
                  </tr>
                  <tr>
                    <td>Problem</td>
                    <td>{state.problem}</td>
                  </tr>

                </tbody>

              </table>
              <h4 className="mb-4">Job Timeline</h4>

              <Timeline
    items={state.history}
  />

              {state.photos && state.photos.length > 0 ?
                <div className="d-block">
                  <h4>Photos</h4>
                  {state.photos.map((val, i) => (
                    <img src={val.preview} key={i} className="img-fluid mb-3" />
                  ))}
                </div> : ''}
            </div>
            :
            <Flex gap="middle" justify="center">
              <Flex gap="middle">
                <Spin tip="Loading" size="small">
                </Spin>

              </Flex>

            </Flex>}
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default ViewJob;
